import { CadeLogo } from '@cade/brand/react';

interface Props {
  size?: number;
  /**
   * Render the amber-disc brand mark (amber disc + dark glyph) instead of the
   * monochrome mark. Used for the sidebar brand lockup and the login/auth
   * screens; inline message avatars and the home greeting keep the monochrome
   * mark. The disc tone still flips per theme via the dual-variant CSS swap below.
   */
  disc?: boolean;
}

export function CadeAvatar({ size = 36, disc = false }: Props) {
  return (
    <span
      className="cade-avatar"
      style={{ width: size, height: size, display: 'inline-flex', flexShrink: 0 }}
      aria-hidden="true"
    >
      <span className="cade-avatar-dark">
        <CadeLogo variant="dark" size={size} disc={disc} />
      </span>
      <span className="cade-avatar-light">
        <CadeLogo variant="light" size={size} disc={disc} />
      </span>
    </span>
  );
}
